var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hexagon-container"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"image",style:({
      backgroundImage: ("url(" + _vm.href + ")"),
      backgroundRepeat: 'no-repeat',
      backgroundSize: '300px 300px'
    })},[_vm._v(_vm._s(_vm.idx)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }